export enum StepViewEnum {
  selectCourse = 'selectCourse',
  date = 'date',
  reservation = 'reservation',
  terms = 'terms',
  checkout = 'checkout',
}

export enum EventStatusEnum {
  approved = 'approved',
  rejected = 'rejected',
}

export enum WpEnvCityEnum {
  th = 'th',
  vn = 'vn',
}

export enum WpEnvCityNameEnum {
  thailand = 'THAILAND',
  vietname = 'VIETNAM',
  vietname_hcm = 'HO CHI MINH',
  vietname_hanoi = 'HANOI',
}

export enum FeaturesGateEnum {
  FEATURE_SPECIAL_COURSE = 'FEATURE_SPECIAL_COURSE',
  CLIENT_BOOKING_LIMIT = 'CLIENT_BOOKING_LIMIT',
  GTM_DATALAYER_BOOKING = 'GTM_DATALAYER_BOOKING',
  BOOKING_GENDER_FIELD = 'BOOKING_GENDER_FIELD',
}
